module.exports = __webpack_public_path__ + "static/media/christian-2.4e3ff7b0.jpg";